export default {
  "备注": "备注",
  "本次发货": "本次发货",
  "本次收货": "本次收货",
  "必填": "必填",
  "标准": "标准",
  "标准调拨": "标准调拨",
  "驳回": "驳回",
  "驳回数量": "驳回数量",
  "驳回数量等于申请数量，请选择审核拒绝": "驳回数量等于申请数量，请选择审核拒绝",
  "不通过": "不通过",
  "仓库名称": "仓库名称",
  "仓库选择": "仓库选择",
  "仓位名称": "仓位名称",
  "创建": "创建",
  "创建区域调拨": "创建区域调拨",
  "创建人": "创建人",
  "创建时间": "创建时间",
  "待发货": "待发货",
  "待收货": "待收货",
  "单位": "单位",
  "地区": "地区",
  "地区数据不全": "地区数据不全",
  "的": "的",
  "调拨单": "调拨单",
  "调拨单号": "调拨单号",
  "调拨单据": "调拨单据",
  "调拨类型": "调拨类型",
  "调拨申请单": "调拨申请单",
  "调拨审批": "调拨审批",
  "调拨详情": "调拨详情",
  "调拨状态": "调拨状态",
  "发货": "发货",
  "发货方式": "发货方式",
  "发货信息": "发货信息",
  "非自提": "非自提",
  "服务商": "服务商",
  "服务商申请调拨": "服务商申请调拨",
  "负责人": "负责人",
  "规格型号": "规格型号",
  "国家/区域": "国家/区域",
  "坏": "坏",
  "坏件申请": "坏件申请",
  "基础信息": "基础信息",
  "仅审批": "仅审批",
  "旧": "旧",
  "旧件申请": "旧件申请",
  "快递发货": "快递发货",
  "来源仓库": "来源仓库",
  "来源仓位": "来源仓位",
  "联系电话": "联系电话",
  "联系邮箱": "联系邮箱",
  "目标仓库": "目标仓库",
  "目标仓库类型不能同时为甲供仓库和常规仓库，请修改": "目标仓库类型不能同时为甲供仓库和常规仓库，请修改",
  "目标仓位": "目标仓位",
  "请补充来源信息": "请补充来源信息",
  "请补充物料": "请补充物料",
  "请上传收货凭证，最多可上传6张图片。": "请上传收货凭证，最多可上传6张图片。",
  "请上传收货照片": "请上传收货照片",
  "请输入": "请输入",
  "请输入备注": "请输入备注",
  "请输入仓库名称": "请输入仓库名称",
  "请输入仓位名称": "请输入仓位名称",
  "请输入调拨单号": "请输入调拨单号",
  "请输入调拨申请单": "请输入调拨申请单",
  "请输入发货快递物流单号": "请输入发货快递物流单号",
  "请输入负责人": "请输入负责人",
  "请输入企业名称": "请输入企业名称",
  "请输入申请人": "请输入申请人",
  "请输入审批单号": "请输入审批单号",
  "请输入审批意见": "请输入审批意见",
  "请输入物料编码": "请输入物料编码",
  "请输入物料单号": "请输入物料单号",
  "请输入物料名称": "请输入物料名称",
  "请输入物料名称,物料编码": "请输入物料名称,物料编码",
  "请添加物料": "请添加物料",
  "请填写收货电话": "请填写收货电话",
  "请填写收货人": "请填写收货人",
  "请填写收货信息": "请填写收货信息",
  "请填写详细地址": "请填写详细地址",
  "请选择": "请选择",
  "请选择地区": "请选择地区",
  "请选择调拨单": "请选择调拨单",
  "请选择发货方式": "请选择发货方式",
  "请选择国家/区域": "请选择国家/区域",
  "请选择来源仓库": "请选择来源仓库",
  "请选择来源仓位": "请选择来源仓位",
  "请选择目标仓库": "请选择目标仓库",
  "请选择目标仓位": "请选择目标仓位",
  "请选择申请企业": "请选择申请企业",
  "请选择申请人": "请选择申请人",
  "请选择审批企业": "请选择审批企业",
  "请选择物料": "请选择物料",
  "请选择物料属性": "请选择物料属性",
  "区域": "区域",
  "区域申请调拨": "区域申请调拨",
  "全部": "全部",
  "全部发货数量不能为0": "全部发货数量不能为0",
  "全部收货数量不能为0": "全部收货数量不能为0",
  "全部物料都已驳回,不可发货": "全部物料都已驳回,不可发货",
  "确定": "确定",
  "确认": "确认",
  "确认发货": "确认发货",
  "确认收货": "确认收货",
  "确认物料": "确认物料",
  "确认要发起申请重试吗?": "确认要发起申请重试吗?",
  "三方发货单号": "三方发货单号",
  "筛选": "筛选",
  "申请": "申请",
  "申请/确认发货": "申请/确认发货",
  "申请单": "申请单",
  "申请发货": "申请发货",
  "申请企业": "申请企业",
  "申请人": "申请人",
  "申请数量": "申请数量",
  "审批": "审批",
  "审批单号": "审批单号",
  "审批结果": "审批结果",
  "审批企业": "审批企业",
  "审批人": "审批人",
  "审批意见": "审批意见",
  "是否自提": "是否自提",
  "收货": "收货",
  "收货地区": "收货地区",
  "收货电话": "收货电话",
  "收货人": "收货人",
  "收货图片": "收货图片",
  "收货信息": "收货信息",
  "收货照片": "收货照片",
  "收件人": "收件人",
  "提交": "提交",
  "提交并发货": "提交并发货",
  "添加收货信息": "添加收货信息",
  "通过": "通过",
  "物料": "物料",
  "物料编码": "物料编码",
  "物料不能为空": "物料不能为空",
  "物料单号": "物料单号",
  "物料调拨": "物料调拨",
  "物料名称": "物料名称",
  "物料清单": "物料清单",
  "物料属性": "物料属性",
  "物料选择": "物料选择",
  "物流单号": "物流单号",
  "物流运输": "物流运输",
  "线下取货": "线下取货",
  "详细地址": "详细地址",
  "新": "新",
  "新件申请": "新件申请",
  "新建成功！": "新建成功！",
  "新增标准调拨": "新增标准调拨",
  "新增服务商申请调拨": "新增服务商申请调拨",
  "新增区域申请调拨": "新增区域申请调拨",
  "选择调拨单": "选择调拨单",
  "选择物料": "选择物料",
  "已复制": "已复制",
  "已添加": "已添加",
  "在途": "在途",
  "暂无数据": "暂无数据",
  "重试": "重试",
  "重置": "重置",
  "自提": "自提"
}
